import Routing from "../../../public/bundles/fosjsrouting/js/router";
const routes = require("../../../public/js/fos_js_routes.json");
Routing.setRoutingData(routes);
window.Routing = Routing;
